export default __webpack_public_path__ + "static/media/forgot_pw.26fad1f6.png";